import type { UserAccountantRequestType } from "@/services/userAccountantRequestsService";
import type { UserNotarialRequestType } from "@/services/userNotarialRequestsService";

export type RequestCategory = "accountant" | "notary";

/** Type chosen in the new-request dialog (notary API vs accountant API). */
export type NewRequestSelectableType = UserNotarialRequestType | UserAccountantRequestType;

const ACCOUNTANT_REQUEST_TYPES: UserAccountantRequestType[] = ["income_certificate"];

const NOTARY_REQUEST_TYPES: UserNotarialRequestType[] = [
  "notarial_legal_entity",
  "notarial_signature",
  "notarial_address",
];

/** All certificate products in wizard step 2 (accountant + notary), stable order. */
export const ALL_CERTIFICATE_TYPES: NewRequestSelectableType[] = [
  ...ACCOUNTANT_REQUEST_TYPES,
  ...NOTARY_REQUEST_TYPES,
];

export function categoryForRequestType(type: NewRequestSelectableType): RequestCategory {
  return type === "income_certificate" ? "accountant" : "notary";
}

export function typesForCategory(category: RequestCategory | null): NewRequestSelectableType[] {
  if (category === "accountant") return ACCOUNTANT_REQUEST_TYPES;
  if (category === "notary") return NOTARY_REQUEST_TYPES;
  return [];
}
